import * as d3 from 'd3';

export const sort = (key, data) => {
    return data.sort((left, right) => {
        return d3.descending(left[key], right[key]);
    });
};